// Selección pendiente del signup (plan + add-ons + ciclo).
//
// La landing (takemyorder.es) recoge la selección del visitante en el
// pricing y la reenvía como query string al portal (app.takemyorder.es)
// en el redirect a `/auth/verify-otp`. localStorage NO cruza subdominios,
// por eso viaja en la URL. `VerifyOtpView` la persiste al montar y el
// wizard onboarding la lee para pre-marcar add-ons.
//
// La selección es "conveniencia" — si se pierde (cookies limpias,
// otro navegador), el user simplemente re-elige en el wizard. No es
// un contrato ni dispara cobros por sí sola.

const STORAGE_KEY = "tmo_pending_selection";

export function savePendingSelection(selection) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
  } catch {
    /* localStorage puede estar deshabilitado — no bloqueamos el flujo */
  }
}

export function readPendingSelection() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearPendingSelection() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* noop */
  }
}

/**
 * Lee la selección del querystring (`?plan=X&cycle=Y&addons=A,B`) y la
 * persiste en localStorage. Se llama desde `VerifyOtpView` al montar.
 * Idempotente — si ya había una selección guardada, la sobreescribe
 * con la nueva (el user pudo cambiar de plan en la landing y reintentar).
 */
export function captureSelectionFromQuery(search) {
  const params = new URLSearchParams(search);
  const planId = params.get("plan");
  const cycle = params.get("cycle");
  const addonsRaw = params.get("addons");
  if (!planId && !addonsRaw) return null;

  const selection = {
    planId: planId ? Number(planId) : undefined,
    cycle: cycle === "annual" ? "annual" : "monthly",
    addOnIds: addonsRaw
      ? addonsRaw
          .split(",")
          .map((s) => Number(s.trim()))
          .filter((n) => Number.isFinite(n) && n > 0)
      : [],
    savedAt: new Date().toISOString(),
  };
  savePendingSelection(selection);
  return selection;
}
